/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function ForElectionWorkersInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="For Election Workers"
              description={
                <>
                  <p>It takes a lot of people and effort to make an election run smoothly. Elections Nova Scotia employees a variety of positions during a provincial general election or by-election. Most election worker positions require you to be an eligible elector (18 years or older, a Canadian citizen, and reside in the province for 6 months). Below is a list of positions which are hired during an election event.</p>
                  <br /><p><u>At the returning office and early voting locations:</u></p>
                  <ul style={{ paddingLeft: "40px" }}>
                    <li>Assistant Returning Officer</li>
                    <li>Revision Assistant</li>
                    <li>Poll Supervisor</li> 
                    <li>Presiding Officer</li>         
                    <li>Write-in Ballot Coordinator</li>     
                    <li>Assistant Write-in Ballot Coordinator</li>              
                    <li>Information Officer</li>     
                    <li>Clerk</li>     
                  </ul>

                  <br /><p><u>At election day voting locations:</u></p>
                  <ul style={{ paddingLeft: "40px" }}>
                    <li>Poll Supervisor</li> 
                    <li>Deputy Returning Officer</li>  
                    <li>Poll Clerk</li>
                    <li>Information Officer</li>   
                    <li>Ballot Box Courier</li>     
                    <li>Constable</li>                                        
                  </ul>
                  <br /><p>The largest group of election workers are hired for election day. Below are links to online training modules. These modules will give you an idea of what these jobs entail.</p>
                  <br />
                  <ul style={{ paddingLeft: "40px" }}>
                    <li><a href="https://share.articulate.com/It9JexgdZZ69lzfG4_lS_">Deputy Returning Officer Election Day Training</a></li> 
                    <li><a href="https://share.articulate.com/Ak60PKaAJNuSgcIRQvGE5">Poll Clerk Election Day Training</a></li>  
                    <li><a href="https://share.articulate.com/_nTSIhyG-FNC4eRbcF2Ez">Poll Supervisor Election Day Training</a></li>                                       
                  </ul>
                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default ForElectionWorkersInformation;
